<template>
  <div class="payment-page style2">
    <h2 class="table-title">
      Nội dung yêu cầu
    </h2>
    <div class="request-form">
      <h4 class="form-title">
        Quý khách vui lòng nhập thông tin theo hướng
        dẫn sau
      </h4>
        <div class="flex flex-wrap -mx-3 mb-6">
          <div
            class="w-full md:w-1/2 px-3 mb-6 md:mb-0"
          >
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Tên chủ xe *
              </label>
              <input
                :class="[ submitted && $v.form.CarOwnerFullName.$error && !$v.form.CarOwnerFullName.required ? 'with-error' : '' ]"
                class="appearance-none border w-full focus:outline-none"
                type="text"
                v-model="form.CarOwnerFullName"
              />
              <p
                v-if="submitted && $v.form.CarOwnerFullName.$error && !$v.form.CarOwnerFullName.required"
                class="text-red-500 text-xs italic"
              >
                Tên chủ xe không được để trống
              </p>
            </div>
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Số điện thoại liên lạc *
              </label>
              <input
                :class="[ submitted && $v.form.Phone.$error && !$v.form.Phone.required ? 'with-error' : '' ]"
                class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none"
                type="text"
                v-model="form.Phone"
              />
              <p
                v-if="submitted && $v.form.Phone.$error && !$v.form.Phone.required"
                class="text-red-500 text-xs italic"
              >
                Số điện thoại không được để trống
              </p>
            </div>
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Địa chỉ email
              </label>
              <input
                class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none"
                type="text"
                v-model="form.Email"
              />
            </div>
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Địa chỉ
              </label>
              <input
                class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none with-error"
                type="text"
                v-model="form.Address"
              />
            </div>
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Số hợp đồng
              </label>
              <input
                class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none"
                type="text"
                v-model="form.ContractNo"
              />
            </div>
            <div class="form-controls">
              <label
                class="block text-sm font-bold mb-2"
              >
                Biển số xe *
              </label>
              <!--<input
                :class="[ submitted && $v.form.PlateNo.$error && !$v.form.PlateNo.required ? 'with-error' : '' ]"
                class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none"
                type="text"
                v-model="form.PlateNo"
              />-->
              <div
                class="inline-block relative w-full"
              >
                <select
                  class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                  v-model="form.PlateNo"
                >
                  <option v-for="(v, index) in plateNos" :key="index" :selected="index === 0">
                    {{v}}
                  </option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    width="19"
                    height="11"
                    viewBox="0 0 19 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1177 0.000166722C17.8886 0.00731876 17.6729 0.107447 17.5145 0.282672L9.4977 8.79002L1.48091 0.282672C1.31747 0.105659 1.09506 0.00553086 0.86086 0.00553086C0.510399 0.00553086 0.195321 0.232608 0.0638974 0.577694C-0.0692101 0.92278 0.00998035 1.31793 0.261032 1.57719L8.88777 10.7318C9.22475 11.0894 9.77066 11.0894 10.1076 10.7318L18.7344 1.57719C18.9905 1.31614 19.0714 0.91384 18.9332 0.565178C18.7967 0.216516 18.4732 -0.00698532 18.1177 0.000166722Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
              <p
                v-if="submitted && $v.form.PlateNo.$error && !$v.form.PlateNo.required"
                class="text-red-500 text-xs italic"
              >
                Biển số xe không được để trống
              </p>
            </div>
          </div>
          <div class="w-full md:w-1/2 px-3">
            <div class="w-full form-controls">
              <label
                class="block mb-2"
                for=""
              >
                Chọn loại yêu cầu *
              </label>
              <div
                class="inline-block relative w-full"
              >
                <select
                  class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                  v-model="form.RequestType"
                >
                  <option v-for="(v, index) in requestTypes" :key="index" :selected="index === 0">
                    {{v}}
                  </option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    width="19"
                    height="11"
                    viewBox="0 0 19 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1177 0.000166722C17.8886 0.00731876 17.6729 0.107447 17.5145 0.282672L9.4977 8.79002L1.48091 0.282672C1.31747 0.105659 1.09506 0.00553086 0.86086 0.00553086C0.510399 0.00553086 0.195321 0.232608 0.0638974 0.577694C-0.0692101 0.92278 0.00998035 1.31793 0.261032 1.57719L8.88777 10.7318C9.22475 11.0894 9.77066 11.0894 10.1076 10.7318L18.7344 1.57719C18.9905 1.31614 19.0714 0.91384 18.9332 0.565178C18.7967 0.216516 18.4732 -0.00698532 18.1177 0.000166722Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
              <p
                v-if="submitted && $v.form.RequestType.$error && !$v.form.RequestType.required"
                class="text-red-500 text-xs italic"
              >
                Loại yêu cầu không được để trống
              </p>
            </div>

            <div class="w-full form-controls">
              <label
                class="block tracking-wide text-gray-700 text-xs font-bold mb-2"
                for=""
              >
                Nội dung yêu cầu *
              </label>
              <textarea
                :class="[ submitted && $v.form.Content.$error && !$v.form.Content.required ? 'with-error' : '' ]"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id=""
                type="text"
                v-model="form.Content"
              ></textarea>
              <p
                v-if="submitted && $v.form.Content.$error && !$v.form.Content.required"
                class="text-red-500 text-xs italic"
              >
                Nội dung không được để trống
              </p>
            </div>
            <form class="js" action="">
              <div
                class="w-full form-controls file-control"
              >
                <div
                  id="fileInputContainer"
                >
                  <div
                    class="input-file-container"
                  >
                    <input
                      class="input-file"
                      id="requestFile"
                      type="file"
                      title=""
                      multiple
                      @change="loadFile"
                      @click="resetInput"
                    />
                    <label
                      tabindex="0"
                      class="input-file-trigger"
                    >TẬP TIN ĐÍNH
                      KÈM</label
                    >
                  </div>
                  <p class="">
                    Tập đính kèm không
                    được quá 3mb hoặc
                    quá 5 tập tin,<br />
                    định dạng pdf, doc,
                    docx, png, jpeg
                  </p>
                  <div
                    class="file-return"
                  >
                    <ul v-if="form.Files.length > 0">
                      <li v-for="(v, index) in form.Files" :key="index">
                        <span class="file-size">{{v.FileName}} ({{ v.FileSize | formatFileSize }})</span>
                        <img class="clearfile-button" width="24" height="24" src="@/assets/img/delete-file.svg" alt="Delete"
                             @click="removeFile(index)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="w-full px-3 text-center">
            <button
              class="primary-button mx-auto"
              @click="submit"
              :disabled="isRequest"
            >
              <vue-element-loading :active="isRequest"/>
              GỬI
            </button>
          </div>
        </div>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownModal">
      <div
        class="modal-file-upload modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto"
      >
        <div class="modal-content">
          <div class="modal-body">
            <h6>
              Tập tin quá lớn hoặc quá số lượng cho phép. Vui lòng
              kiểm tra lại
            </h6>
            <p>
              Tập tin không quá 3mb và không quá 5 tập tin.
            </p>
            <a class="primary-button modal-close" href="javascript:void(0)" @click="closeModal">TẢI LẠI</a>
          </div>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
// import * as external from '@/assets/external.js'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { SupportService } from '@/services/support.service'
import UiModal from '@/components/UiModal.vue'

export default {
  name: 'SupportRequest',
  mixins: [validationMixin],
  components: {
    UiModal
  },
  data () {
    return {
      form: {
        CarOwnerFullName: '',
        Phone: '',
        Email: '',
        Address: '',
        ContractNo: '',
        PlateNo: '',
        Content: '',
        RequestType: '',
        Files: []
      },
      isShownModal: false,
      requestTypes: [],
      plateNos: [],
      submitted: false,
      fileContent: '',
      isRequest: false
    }
  },
  validations: {
    form: {
      CarOwnerFullName: { required },
      Phone: { required },
      PlateNo: { required },
      RequestType: { required },
      Content: { required }
    }
  },
  methods: {
    removeFile (index) {
      this.form.Files.splice(index, 1)
    },
    resetInput () {
      var fileLoader = document.getElementById('requestFile')
      if (fileLoader.files.length > 0) {
        fileLoader.value = null
      }
    },
    loadFile () {
      const self = this
      // return new Promise((resolve, reject) => {
      self.form.Files = []
      self.fileArr = []
      const files = document
        .getElementById('requestFile')
        .files

      // if (files.length === 0) {
      //  resolve(true)
      // }

      if (files.length > 5) {
        self.isShownModal = true
        return false
      }

      files.forEach(file => {
        const fileSize = file.size / 1024 / 1024
        if (fileSize > 3) {
          self.isShownModal = true
          return false
        }

        const reader = new FileReader()
        reader.onload = (e) => {
          const b64 = e.target.result.replace(/^data:.+;base64,/, '')
          const f = {
            FileName: file.name,
            FileContent: b64,
            FileSize: file.size
          }
          self.form.Files.push(f)
        }
        reader.onerror = function (error) {
          alert(error)
        }
        reader.readAsDataURL(file)
      })
      return true
    },
    async validateFilesForm () {
      if (this.form.Files.length > 5) {
        return false
      }

      this.form.Files.forEach(v => {
        const fileSize = v.FileSize / 1024 / 1024
        if (fileSize > 3) {
          return false
        }
      })
      return true
    },
    async submit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const result = await this.validateFilesForm()
      if (result === false) {
        this.isShownModal = true
        return
      }
      this.isRequest = true
      SupportService.sendRequestSupportForm(this.form).then(response => {
        if (response.data.data.IsResult === true) {
          this.$router.push({ name: 'requestSuccess' })
          return
        }
        this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
        this.isRequest = false
      })
    },
    async getRequestType () {
      SupportService.getListRequestType().then(response => {
        if (response.data.data.length > 0) {
          this.requestTypes = response.data.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    async getPlateNo () {
      SupportService.getListPlateNo().then(result => {
        if (result.data.PlateNos.length > 0) {
          this.plateNos = result.data.PlateNos
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    closeModal () {
      this.isShownModal = false
    }
  },
  filters: {
    formatFileSize: function (size) {
      let suffix = 'bytes'
      if (size >= 1024 && size < 1024000) {
        suffix = 'KB'
        size = Math.round((size / 1024) * 100) / 100
      } else if (size >= 1024000) {
        suffix = 'MB'
        size = Math.round((size / 1024000) * 100) / 100
      }
      return size + ' ' + suffix
    }
  },
  created () {
    this.getRequestType()
    this.getPlateNo()
  },
  mounted () {
    // external.head_script('/js/fileInput.js')
  }
}
</script>
